import { render, staticRenderFns } from "./PopupPaymentTeacher.vue?vue&type=template&id=0d5a0170&"
import script from "./PopupPaymentTeacher.vue?vue&type=script&lang=js&"
export * from "./PopupPaymentTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports